export default "__VITE_ASSET__RgnUYMii__"